export const APP_TIMEZONE = 'Europe/Oslo';
